@use "variables" as *;

.dialog {
  display: flex;
  flex-direction: column;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.image {
  aspect-ratio: 1;
  border-radius: 6%;
}

.title {
  font-size: $fontSize-xs;
}

.realName {
  margin: 0;
}

.artistDates {
  font-size: $fontSize-xxs;
}

.profile {
  font-size: $fontSize-xs;
  white-space: pre-wrap;
}

.redirectButton {
  width: 100%;
  margin: 0 !important;
}

.redirectGridItem {
  padding: $spacing-s;
}
